// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.report-complete {\n  color: #00ccd8;\n}\n.error {\n  color: #f44271;\n}\n.largeFont {\n  font-size: large;\n  color: #f44271;\n}\n.report-open {\n  color: #ff6767;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
